import { useNavigate } from "react-router";
import { useCallback } from "react";
import { NoInvoiceMoneyTransferScreenPath } from "./NoInvoiceMoneyTransferScreen.tsx";

export function useToMoneyTransferWithoutInvoice() {
  const navigate = useNavigate();

  const toMoneyTransferWithoutInvoice = useCallback(
    ({ productId, priceId }: { productId: string; priceId: string }) => {
      navigate(
        `${NoInvoiceMoneyTransferScreenPath}?productId=${productId}&priceId=${priceId}`,
      );
    },
    [navigate],
  );

  return {
    toMoneyTransferWithoutInvoice,
  };
}
